import { archive } from '../../actionTypes';

const initialState = {
  items: [],
  total: 0,
  loading: false,
  error: null,
};

export default function list(state = initialState, action) {
  switch (action.type) {
    case archive.user.get.start:
      return {
        ...initialState,
        loading: true,
      };
    case archive.user.get.end:
      return {
        ...state,
        loading: false,
        total: action.payload.total,
        items: action.payload.list,
      };
    case archive.user.get.error:
      return {
        ...state,
        error: action.payload.error,
      };

    case archive.user.recover.start:
      return { ...state, loading: true };
    case archive.user.recover.end:
      return {
        ...state,
        loading: false,
        total: action.payload.total,
        items: action.payload.list,
      };
    case archive.user.recover.error:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
